var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 6.7417C17.9469 6.7417 18.5625 6.12609 18.5625 5.3667C18.5625 4.60731 17.9469 3.9917 17.1875 3.9917C16.4281 3.9917 15.8125 4.60731 15.8125 5.3667C15.8125 6.12609 16.4281 6.7417 17.1875 6.7417Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 3.9917V2.96045",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9964 4.6792L15.1035 4.16357",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9964 6.0542L15.1035 6.56982",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 6.7417V7.77295",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3789 6.0542L19.2718 6.56982",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3789 4.6792L19.2718 4.16357",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.3042C12.8985 14.3042 14.4375 12.7652 14.4375 10.8667C14.4375 8.96822 12.8985 7.4292 11 7.4292C9.10152 7.4292 7.5625 8.96822 7.5625 10.8667C7.5625 12.7652 9.10152 14.3042 11 14.3042Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48242 17.6877C5.99969 16.6689 6.78898 15.8132 7.76281 15.2154C8.73664 14.6177 9.85697 14.3013 10.9996 14.3013C12.1423 14.3013 13.2626 14.6177 14.2364 15.2154C15.2102 15.8132 15.9995 16.6689 16.5168 17.6877",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1356 10.1792C19.4256 11.9026 19.1605 13.6735 18.3784 15.2363C17.5963 16.7991 16.3378 18.073 14.7845 18.8738C13.2313 19.6747 11.4637 19.9613 9.73696 19.6921C8.01024 19.4228 6.41376 18.6118 5.17804 17.3761C3.94231 16.1404 3.13129 14.5439 2.86208 12.8172C2.59286 11.0905 2.87939 9.32285 3.68029 7.7696C4.48119 6.21634 5.755 4.95782 7.31782 4.17573C8.88063 3.39365 10.6516 3.12849 12.3749 3.41853",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarUser);
export default __webpack_public_path__ + "static/media/icon-sidebar-user.bc227fc8a87695aeab368efe5fb7aa26.svg";
export { ForwardRef as ReactComponent };